import { IExperiment } from '../../types/experiments';
import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): IExperiment[] => state.experiments;
